<script>
  import { Button, Modal, FileUpload } from "../../../components/index.svelte";
  import { getMaintenanceDetails } from "../../../helpers/apiHelpers/index.svelte";
  import { translator } from "../../../store";

  export let onModalClose;
  let maintenanceDetails;
  let maintenanceTypeOptions = [
    { text: translator("CLEANING"), value: "CLEANING" },
    { text: translator("REPAIRING"), value: "REPAIRING" },
    { text: translator("FIXTURE"), value: "FIXTURE" },
    { text: translator("GROCERY"), value: "GROCERY" },
    { text: translator("LOAN"), value: "LOAN" },
    { text: translator("BILL"), value: "BILL" },
  ]
  export async function modalToggleWrapper(propertyID, maintenanceID) {
    toggler();
    if (maintenanceID) {
      maintenanceDetails = await getMaintenanceDetails(
        propertyID,
        maintenanceID,
        true
      );
    }
  }

  let toggler;
</script>

<Modal
  bind:toggle={toggler}
  title={translator("Masraf Detayları")}
  onClose={onModalClose}
>
  <div slot="modal-body">
    {#if maintenanceDetails}
    <div class="profile-personal-info">
      <div class="row mb-2">
        <div class="col-sm-3 col-5">
          <h5 class="f-w-500">{translator("Mülk Adı")}<span class="pull-end">:</span></h5>
        </div>
        <div class="col-sm-9 col-7"><span>{maintenanceDetails.property_details.name}</span></div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3 col-5">
          <h5 class="f-w-500">{translator("Görevli Kişi")}<span class="pull-end">:</span></h5>
        </div>
        <div class="col-sm-9 col-7"><span>{maintenanceDetails.employee || '-'}</span></div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3 col-5">
          <h5 class="f-w-500">{translator("Masraf Tipi")}<span class="pull-end">:</span></h5>
        </div>
        <div class="col-sm-9 col-7"><span>{maintenanceTypeOptions.filter(i1 => i1.value == maintenanceDetails.type)[0].text}</span></div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3 col-5">
          <h5 class="f-w-500">{translator("Açıklama")}<span class="pull-end">:</span></h5>
        </div>
        <div class="col-sm-9 col-7"><span>{maintenanceDetails.description}</span></div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3 col-5">
          <h5 class="f-w-500">{translator("Masraf Tutarı")}<span class="pull-end">:</span></h5>
        </div>
        <div class="col-sm-9 col-7"><span>{maintenanceDetails.cost} ₺</span></div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-3 col-5">
          <h5 class="f-w-500">{translator("Tarih")}<span class="pull-end">:</span></h5>
        </div>
        <div class="col-sm-9 col-7"><span>{maintenanceDetails.operation_date}</span></div>
      </div>
      {#if maintenanceDetails?.files?.length > 0}
        <div class="row mb-2">
          <div class="col-sm-3 col-12">
            <h5 class="f-w-500">{translator("Dosyalar")}<span class="pull-end">:</span></h5>
          </div>
          <div class="col-sm-9 col-12">
            <FileUpload
              fieldName="files[]"
              isViewMode={true}
              multiple={true}
              required={false}
              selectedFiles={maintenanceDetails?.files || []}
            />
          </div>
        </div>
      {/if}
    </div>
    {/if}
  </div>
  <div slot="modal-footer">
    <Button size="sm" onClick={modalToggleWrapper} colorCls="btn-dark">
      {translator("Geri Dön")}
    </Button>
  </div>
</Modal>
